import React, { Component } from "react";
import {
  Card,
  Row,
  Col,
  Table,
  Button,
  Input,
  ButtonGroup,
  Alert as Alert2,
  Label
} from "reactstrap";
import { api, filterHelper } from "../helpers";
import {
  TextFilter,
  FilterSet,
  SelectFilter,
  ActiveToggleFilter,
  Pager
} from "../components";
import Alert from "react-s-alert";
import _ from "lodash";
import "./Site.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const emptyProduct = {
  name: "",
  sku: "",
  preferredDemandDays: "",
  productTypeId: null,
  productGroupId: null,
  isBundleProduct: false,
  isThirdPartyProduct: false,
  includeInDemandReport: true,
  productUnitOfMeasureId: null,
  scLabAlias: "",
  eurofinAlias: ""
};

const getProductTypes = () =>
  api
    .fetch("Reference/ProductTypes")
    .then(response => {
      return {
        productTypeList: _.map(response.data, l => { l.label = l.name; l.value = l.id; return l; })
      };
    })
    .catch(x => console.error(x));

const getProductGroups = () =>
  api
    .fetch("Reference/ProductGroups")
    .then(response => {
      return {
        productGroupList: _.map(response.data, l => { l.label = l.name; l.value = l.id; return l; })
      };
    })
    .catch(x => console.error(x));

const getProductUnitsOfMeasure = () =>
  api
    .fetch("Reference/ProductUnitOfMeasures")
    .then(response => {
      return {
        productUnitOfMeasureList: _.map(response.data, l => { l.label = l.name; l.value = l.id; return l; })
      };
    })
    .catch(x => console.error(x));

export default class Product extends Component {
  static displayName = Product.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      productGroupList: [],
      productTypeList: [],
      editProduct: null,
      filters: [],
      pagedList: null,
      sortColumn: "Id",
      sortAscending: true,
      productUnitOfMeasureList: []
    };
    this.addProduct = this.addProduct.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.getProductName = this.getProductName.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
  }

  componentDidMount() {
    Promise.all([getProductTypes(), getProductGroups(), getProductUnitsOfMeasure()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => {
        this.onChangeFilter({
          filterName: "activeOnly",
          value: true,
          filteredDisplay: "Active Only"
        });
      });
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page:
        pageNumber ||
        (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/Products", payload).then(response => {
      if (response && response.data) {
        this.setState({
          ...resolvedSort,
          pagedList: {
            list: response.data.dataSource,
            pageNumber: response.data.page,
            pageSize: response.data.pageSize,
            totalItems: response.data.totalItems,
            totalPages: response.data.totalPages
          },
          filters: resolvedFilters,
          editProduct: null,
          message: null,
          messageColor: null,
          isMessageVisible: false
        });
      }
    });
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(this.state.filters, changedFilter);
    this.setState({ filters: filters });
    this.refreshList(null, null, filters, 1);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  addProduct() {
    this.setState({
      editProduct: emptyProduct
    });
  }

  onInputChange(e, fieldName) {
    this.setState({
      editProduct: { ...this.state.editProduct, [fieldName]: e.target.value }
    });
  }

  onSelectChange(selection, fieldName) {
    this.setState({
      editProduct: {
        ...this.state.editProduct,
        [fieldName]: selection.target.value
      }
    });
  }

  onCancel() {
    this.setState({
      editProduct: null
    });
  }

  isFormValid() {
    let warnings = [];
    if (this.state.editProduct.name === "") {
      warnings.push("Please enter a product name");
    }
    if (this.state.editProduct.sku === "") {
      warnings.push("Please enter a product sku");
    }
    if (
      !this.state.editProduct.productGroupId ||
      this.state.editProduct.productGroupId === null
    ) {
      warnings.push("Please select a group type");
    }
    if (
      !this.state.editProduct.productTypeId ||
      this.state.editProduct.productTypeId === null
    ) {
      warnings.push("Please select a product type");
    }
    if (this.state.editProduct.preferredDemandDays === "") {
      warnings.push("Preferred demand day is required");
    }
    this.setState({
      message: warnings.length ? warnings.join(", ") : null,
      messageColor: "danger",
      isMessageVisible: true
    });
    return warnings.length === 0;
  }

  onSave() {
    if (!this.isFormValid()) return;
    let product = Object.assign({}, this.state.editProduct);
    let payload = {
      Name: product.name,
      SKU: product.sku,
      ProductGroupId: product.productGroupId !== null ? parseInt(product.productGroupId, 10) : null,
      ProductTypeId: product.productTypeId !== null ? parseInt(product.productTypeId, 10): null,
      IsThirdPartyProduct: product.isThirdPartyProduct,
      IsBundleProduct: product.isBundleProduct,
      PreferredDemandDays: parseInt(product.preferredDemandDays, 10),
      IncludeInDemandReport: product.includeInDemandReport,
      UnitOfMeasureId: product.unitOfMeasureId === null ? null : parseInt(product.unitOfMeasureId, 10),
      SCLabAlias: product.scLabAlias,
      EurofinAlias: product.eurofinAlias
    };

    if (product.id) {
      payload.Id = product.id;
    }

    api
      .post("Admin/SaveProduct", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(
            `${product.name} was ${product.id ? "updated" : "created"}.`
          );
          this.refreshList();
          this.props.refreshAll();
        } else {
          Alert.error(
            response.data.message
          );
        }
      })
      .catch(error => Alert.error("There was an error creating the Product."));
  }

  onEdit(productId) {
    let list = this.state.pagedList.list.slice();
    let product = _.find(list, p => {
      return p.id === productId;
    });

    this.setState({
      editProduct: product
    });

    window.scrollTo(0, 0);
  }

  onDelete(productId) {
    const productName = this.getProductName(productId);
    if (!window.confirm(`Are you sure you'd like to delete ${productName}?`))
      return;

    api
      .delete(`Admin/DeleteProduct/${productId}`)
      .then(response => {
        if (response.data.success) {
          Alert.success(`${productName} was deleted.`);
          this.refreshList();
        } else {
          Alert.error(
            "An error occurred. Product cannot be deleted at this time."
          );
        }
      })
      .catch(error => {
        Alert.error(`There was an error deleting ${productName}.`);
      });
  }

  onRevive(productId) {
    const productName = this.getProductName(productId);

    api
      .post("Admin/ReviveProduct", productId)
      .then(response => {
        if (response.data.success) {
          Alert.success(`${productName} was revived.`);
          this.refreshList();
        } else {
          Alert.error(
            `An error occurred. ${productName} cannot be revived at this time.`
          );
        }
      })
      .catch(error =>
        Alert.error(`There was an error reviving the ${productName}.`)
      );
  }

  onCheckBoxChange(fieldName) {
    this.setState({
      editProduct: {
        ...this.state.editProduct,
        [fieldName]: !this.state.editProduct[fieldName]
      }
    });
  }

  getProductName(productId) {
    let list = this.state.pagedList.list.slice();
    return _.find(list, p => {
      return p.id === productId;
    }).name;
  }
  render() {
    let editProduct = this.state.editProduct;
    return (
      <div>
        <Row>
          <Col>
            <h5>Products</h5>
          </Col>
          <Col className="mr-3">
            {this.state.editProduct ? null : (
              <Button
                size="sm"
                color="success"
                className="float-right"
                onClick={this.addProduct}
              >
                Add New Product
              </Button>
            )}
          </Col>
        </Row>

        {this.state.message ? (
          <Alert2
            color={this.state.messageColor}
            toggle={() => this.onDismiss()}
          >
            {this.state.message}
          </Alert2>
        ) : null}

        {editProduct ? (
          <Card className="p-2">
            <Row>
              <Col>
                Name:{" "}
                <Input
                  type="text"
                  name="name"
                  id="name"
                  maxLength="85"
                  onChange={e => this.onInputChange(e, "name")}
                  value={editProduct.name}
                />
              </Col>
              <Col>
                SKU:{" "}
                <Input
                  type="text"
                  name="sku"
                  id="sku"
                  maxLength="18"
                  onChange={e => this.onInputChange(e, "sku")}
                  value={editProduct.sku}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                Product Type:
                <select
                  name="productTypeId"
                  id="productTypeId"
                  className="form-control"
                  onChange={e => this.onSelectChange(e, "productTypeId")}
                >
                  <option value="">Select a type</option>
                  {this.state.productTypeList.length > 0 &&
                    this.state.productTypeList.map(type => (
                      <option
                        key={type.id}
                        value={type.id}
                        selected={editProduct.productTypeId === type.id}
                      >
                        {type.name}
                      </option>
                    ))}
                </select>
              </Col>
              <Col>
                Product Group:
                <select
                  name="productGroupId"
                  id="productGroupId"
                  className="form-control"
                  onChange={e => this.onSelectChange(e, "productGroupId")}
                >
                  <option value="">Select a group</option>
                  {this.state.productGroupList.length > 0 &&
                    this.state.productGroupList.map(group => (
                      <option
                        key={group.id}
                        value={group.id}
                        selected={editProduct.productGroupId === group.id}
                      >
                        {group.name}
                      </option>
                    ))}
                </select>
              </Col>
              <Col>
                Unit Of Measure:
                <select
                  name="unitOfMeasureId"
                  id="unitOfMeasureId"
                  className="form-control"
                  onChange={e => this.onSelectChange(e, "unitOfMeasureId")}
                >
                  <option value="">Select a unit</option>
                  {this.state.productUnitOfMeasureList.length > 0 &&
                    this.state.productUnitOfMeasureList.map(unit => (
                      <option
                        key={unit.id}
                        value={unit.id}
                        selected={editProduct.unitOfMeasureId === unit.id}
                      >
                        {unit.name}
                      </option>
                    ))}
                </select>
              </Col>

            </Row>
            <Row className="mt-2">
              <Col>
                <Row>
                  <Col>
                    Preferred Demand Days:
                    <Input
                      type="number"
                      className="form-control mr-2"
                      id="preferredDemandDays"
                      name="preferredDemandDays"
                      value={editProduct.preferredDemandDays}
                      onChange={e => this.onInputChange(e, "preferredDemandDays")}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    SCLab Alias:
                    <Input
                      type="text"
                      className="form-control mr-2"
                      id="scLabAlias"
                      name="scLabAlias"
                      value={editProduct.scLabAlias}
                      onChange={e => this.onInputChange(e, "scLabAlias")}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    Eurofin Alias:
                    <Input
                      type="text"
                      className="form-control mr-2"
                      id="eurofinAlias"
                      name="eurofinAlias"
                      value={editProduct.eurofinAlias}
                      onChange={e => this.onInputChange(e, "eurofinAlias")}
                      disabled={true}
                    />
                  </Col>
                </Row>

              </Col>
              <Col className="mt-4">
                <Label for="isBundleProduct" className="mr-4">
                  <input
                    type="checkbox"
                    className="mr-2"
                    id="isBundleProduct"
                    name="isBundleProduct"
                    checked={editProduct.isBundleProduct}
                    value={editProduct.isBundleProduct}
                    onClick={() => this.onCheckBoxChange("isBundleProduct")}
                  />
                  Is Bundle Product?
                </Label>
                <Label for="isThirdPartyProduct" className="mr-4">
                  <input
                    type="checkbox"
                    className="mr-2"
                    id="isThirdPartyProduct"
                    name="isThirdPartyProduct"
                    checked={editProduct.isThirdPartyProduct}
                    value={editProduct.isThirdPartyProduct}
                    onClick={() => this.onCheckBoxChange("isThirdPartyProduct")}
                  />
                  Is Third Party Product?
                </Label>
                <Label for="includeInDemandReport">
                  <input
                    type="checkbox"
                    className="mr-2"
                    id="includeInDemandReport"
                    name="includeInDemandReport"
                    checked={editProduct.includeInDemandReport}
                    value={editProduct.includeInDemandReport}
                    onClick={() => this.onCheckBoxChange("includeInDemandReport")}
                  />
                  Include In Daily Demand Report?
                </Label>

              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ButtonGroup className="float-right">
                  <Button
                    size="sm"
                    color="secondary"
                    className="buttonGroupSpacing"
                    onClick={this.onCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    size="sm"
                    className="cbdmdPrimary buttonGroupSpacing"
                    onClick={() => this.onSave()}
                  >
                    {editProduct.id ? "Update" : "Save"}
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>
        ) : null}
        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet
              filters={this.state.filters}
              clearFilters={this.clearFilters}
              childrenClassName="pt-2 cursor"
            >
              <Col xs="3">
                <TextFilter
                  filterName="name"
                  displayName="Product Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
                <TextFilter
                  filterName="sku"
                  displayName="Sku"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              {/*<Col xs="3">
                <TextFilter
                  filterName="productTypeName"
                  displayName="Product Type Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>*/}
              <Col xs="3">
                <SelectFilter
                  filterName="productTypeId"
                  displayName="Product Type"
                  isSingleSelect={true}
                  options={this.state.productTypeList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "productTypeId",
                    this.state.filters
                  )}
                />
              </Col>

              <Col xs="3">
                <SelectFilter
                  filterName="productGroupId"
                  displayName="Product Group"
                  isSingleSelect={true}
                  options={this.state.productGroupList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "productGroupId",
                    this.state.filters
                  )}
                />
              </Col>
              {/*<Col xs="3">
                <TextFilter
                  filterName="productGroupName"
                  displayName="Product Group Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>*/}
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="activeOnly"
                  displayName="Active Only"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "activeOnly",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="isBundleProduct"
                  displayName="Bundle?"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "isBundleProduct",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="isThirdPartyProduct"
                  displayName="Third Party?"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "isThirdPartyProduct",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="includeInDemandReport"
                  displayName="Included In Demand Report?"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "includeInDemandReport",
                    this.state.filters
                  )}
                />
              </Col>

            </FilterSet>
          </Col>
        </Row>

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Sku</th>
                  <th>Product Type</th>
                  <th>Product Group</th>
                  <th>Bundle?</th>
                  <th>Third Party?</th>
                  <th>Include In Report?</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0
                  ? this.state.pagedList.list.map(product => (
                      <tr key={product.id}>
                        <td>
                          {product.name}
                          {product.productGroupId === 0 ? (
                            <span className="ml-2">
                              <FontAwesomeIcon
                                icon="exclamation-circle"
                                title="Requires group and type association"
                                className="warningAlert"
                              />
                            </span>
                          ) : null}
                        </td>
                        <td>{product.sku}</td>
                        <td>{product.productTypeName}</td>
                        <td>{product.productGroupName}</td>
                        <td>
                          {product.isBundleProduct ? (
                            <FontAwesomeIcon
                              icon="check-circle"
                              className="ml-1 mt-0 mb-0 mr-2 pointer bool-icon"
                              title="Yes"
                            />
                          ) : null}
                        </td>
                        <td>
                          {product.isThirdPartyProduct ? (
                            <FontAwesomeIcon
                              icon="check-circle"
                              className="ml-1 mt-0 mb-0 mr-2 pointer  bool-icon"
                              title="Yes"
                            />
                          ) : null}
                        </td>
                      <td>
                        {product.includeInDemandReport ? (
                          <FontAwesomeIcon
                            icon="check-circle"
                            className="ml-1 mt-0 mb-0 mr-2 pointer  bool-icon"
                            title="Yes"
                          />
                        ) : null}
                      </td>
                        <td>
                          <ButtonGroup>
                            {product.deactivatedAt ? (
                              <Button
                                size="sm"
                                className="cbdmdInfoTeal"
                                onClick={() => this.onRevive(product.id)}
                                disabled={this.state.editProduct !== null}
                              >
                                Revive
                              </Button>
                            ) : (
                              <React.Fragment>
                                <Button
                                  size="sm"
                                  className="cbdmdPrimary buttonGroupSpacing"
                                  onClick={() => this.onEdit(product.id)}
                                  disabled={this.state.editProduct !== null}
                                  title="Edit"
                                >
                                  <FontAwesomeIcon
                                    icon="edit"
                                    className="ml-1 mt-0 mb-0 mr-1 pointer"
                                    title="Edit"
                                  />
                                </Button>
                                <Button
                                  size="sm"
                                  className="cbdmdDanger buttonGroupSpacing"
                                  onClick={() => this.onDelete(product.id)}
                                  disabled={this.state.editProduct !== null}
                                  title="Delete"
                                >
                                  <FontAwesomeIcon
                                    icon="trash-alt"
                                    className="ml-1 mt-0 mb-0 mr-1 pointer"
                                    title="Delete"
                                  />
                                </Button>
                              </React.Fragment>
                            )}
                          </ButtonGroup>
                        </td>
                      </tr>
                    ))
                  :
                    <tr>
                      <td>
                        No Records available
                      </td>
                    </tr>
                  }
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Product.js